import { Routes, RouterModule } from '@angular/router';
import { SuppliersBarcodesComponent } from './supplier-barcodes.component';

const routes: Routes = [
  {
    path: '',
    component: SuppliersBarcodesComponent
  },
];

export const SuppliersBarcodesRouting = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/suppliers-barcodes/supplier-barcodes.routing.ts